import React from 'react';
import classNames from 'classnames';

import { Button } from '../button';
import { EventTile } from '../event-tile';
import { TitleDivider } from '../title-divider';
import moment from 'moment';

export class EventGrid extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      showFilters: false,
      events: this.props.events || []
    };
  }

  get className () {
    return classNames({
      'event-grid': true,
      'event-grid--show-filters': this.props.showFilters
    })
  }

  componentDidMount () {
    this.sortEvents();
    this.loadFilters();
  }

  sortEvents = (callback) => {
    const now = moment();

    var events = [...this.props.events];

    events.forEach(event => {
      if (event.eventSchedule) {
        if (event.eventSchedule[0].schedule) {
          event.startDate = new Date(event.eventSchedule[0].schedule[0].startDate);
        }
        
        event.hasPassed = event.eventSchedule.every(schedule => schedule.schedule && schedule.schedule.every(time => {
          const endTime = moment(time.endDate || time.startDate);
          return endTime.isBefore(now);
        }))
      }
    })

    events = events.sort((a, b) => a.startDate - b.startDate);

    const eventsNotPassed = events.filter(event => !event.hasPassed);
    const eventsPassed = events.filter(event => event.hasPassed);
    
    const baseEvents = [...eventsNotPassed, ...eventsPassed];

    this.setState({ baseEvents }, callback);
  }

  toggle = (key, value) => {
    if (value === this.state[key]) {
      value = false;
    }

    this.setState({ [key]: value }, this.filterEvents);
  }

  saveFilters = () => {
    const data = JSON.stringify({
      location: this.state.location,
      category: this.state.category,
      tag: this.state.tag
    });

    sessionStorage.setItem('europalia-filters', data);
  }

  loadFilters = () => {
    const data = sessionStorage.getItem('europalia-filters');
    if (data) this.setState({ ...JSON.parse(data) }, () => {
      this.sortEvents();
      this.filterEvents();
    });
  }

  filterEvents = () => {
    this.saveFilters();

    var events = [...this.state.baseEvents];

    if (this.state.category)
      events = events.filter(event => event.categories && event.categories.some(category =>  category.id === this.state.category));

    if (this.state.tag)
      events = events.filter(event => event.tags && event.tags.some(tag => tag.id === this.state.tag));
    
    if (this.state.location) {
      events = events.filter(event => event.eventSchedule && event.eventSchedule.some(schedule => schedule.location?.region?.id === this.state.location));
    }
      
  
    this.setState({ events });
  }

  render () {
    return (
      <section className="event-grid">
        {
          (this.props.featuredEvents && this.props.featuredEvents.length > 0) && (
            <React.Fragment>
              <TitleDivider>{this.props.featuredEventsTitle}</TitleDivider>
              <div className="event-grid__events">
                { this.props.featuredEvents.map(event => <EventTile {...event} key={event.id} />) }
              </div>
            </React.Fragment>
          )
        }

        <TitleDivider>{this.props.title}</TitleDivider>
        <div className="event-grid__filters-closed">
          <div className="event-grid__filters-closed__title">
            Filter events
            — Tell us what you like

            <Button onClick={() => this.setState({ showFilters: true })}>Show filters</Button>
          </div>
        </div>
        <div className="event-grid__filters">
          { /*
          <div className="event-grid__filters__title">I would like to visit:</div>
          <div className="event-grid__filters__items">
            <button className="button">Today</button>
            <button className="button">This week</button>
            <button className="button">This month</button>
          </div>
          */ }
          <div className="event-grid__filters__title">I am interested in</div>
          <div className="event-grid__filters__items">
            { this.props.filterCategories.map(category => {
              const className = classNames({ 'button': true, 'button--selected': this.state.category === category.id });
              return <button className={className} onClick={() => this.toggle('category', category.id)}>{ category.title }</button>;
            }) }
          </div>
          <div className="event-grid__filters__title">Location</div>
          <div className="event-grid__filters__items">
            { this.props.filterLocations.map(location => {
              const className = classNames({ 'button': true, 'button--selected': this.state.location === location.id });
              return <button className={className} onClick={() => this.toggle('location', location.id)}>{ location.name }</button>;
            }) }
          </div>
          <div className="event-grid__filters__title">Tag</div>
          <div className="event-grid__filters__items">
            { this.props.filterTags.map(tag => {
              const className = classNames({ 'button': true, 'button--selected': this.state.tag === tag.id });
              return <button className={className} onClick={() => this.toggle('tag', tag.id)}>{ tag.name }</button>;
            }) }
          </div>
        </div>
        <div className="event-grid__events">
          { this.state.events && this.state.events.map(event => <EventTile {...event} key={event.id} />) }
        </div>
      </section>
    );
  }
}
